export const alarmPermissions = {
  read: [28],
  write: [28],
  admin: [28],
} as any;